import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { NgxSpinnerService } from 'ngx-spinner';
import { AlertComponent } from '../../../../shared/modals/alert/alert.component';
import { SuccessComponent } from '../../../../shared/modals/success/success.component';
import { EditGroupComponent } from './components/edit-group/edit-group.component';
import { GroupService } from './group.service';

@Component({
  selector: 'app-group',
  templateUrl: './group.component.html',
  styleUrls: ['./group.component.scss']
})
export class GroupComponent implements OnInit {

  displayedColumns: string[] = ['id','name','active', 'edit','delete'];
  dataSource = new MatTableDataSource<any>([]);
  isLoading = true;

  @ViewChild(MatPaginator)
  paginator!: MatPaginator;

  constructor(public dialog: MatDialog,
              private groupService: GroupService,
              private spinner: NgxSpinnerService) { }

  ngOnInit(): void {
    this.spinner.show();
    this.getGroup();
  }

  async getGroup(){
   await this.groupService.getGroup().subscribe(data => {
    if(data.length > 0){
      this.dataSource = new MatTableDataSource<any>(data);
      console.log(this.dataSource);
      this.dataSource.paginator = this.paginator;
      this.isLoading = false;
    } this.spinner.hide();
    });

  }

  editGroup(data:any=null) {
    const dialogRef = this.dialog.open(EditGroupComponent,{
      data:data,
      maxWidth: '80%',
		  minWidth: 'fit-content'
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
    });
  }

  // viewGroup(data:any){
  //   const dialogRef = this.dialog.open(ViewGroupComponent,{
  //     data:data,
  //     width: '100vw'
  //   });

  //   dialogRef.afterClosed().subscribe(result => {
  //     console.log(`Dialog result: ${result}`);
  //   });
  // }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  deleteGroup(data:any=null){
    console.log(data)
    const dialogRef = this.dialog.open(AlertComponent,{
      data:{
        title:"Are you sure!",
        subTitle:"Do you want to delete this Group"
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
      if(result){
        this.spinner.show();
        this.groupService.deleteGroup(data.id);
        this.spinner.hide();
        this.dialog.open(SuccessComponent,{data:{title:"Deleted!",subTitle:"Group deleted successfully."}});
      }
    });
  }
}
